import { render, staticRenderFns } from "./DefaultProductRow.vue?vue&type=template&id=a6bf9adc"
import script from "./DefaultProductRow.vue?vue&type=script&lang=js"
export * from "./DefaultProductRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports